import React from 'react';

import { createApiHooks } from '@apis/next/common';
import { Layout } from '@components/Layout';
import { z } from 'zod';

const badUserHooks = createApiHooks('/user', [
  {
    method: 'get',
    path: '/',
    response: z.object({
      email: z.string(),
      last_name: z.string(),
      first_name: z.string(),
      role: z.string().array(),
    }),
  },
]);

export const TestNextBadResponse = () => {
  const user = badUserHooks.useGet('/user');

  return (
    <Layout title="TestNextBadResponse" loading={user.isLoading} errors={[user.error]}>
      This should show the API Error Dialog
    </Layout>
  );
};
